import { render, staticRenderFns } from "./DashItem.vue?vue&type=template&id=73f3edee&scoped=true"
import script from "./DashItem.vue?vue&type=script&lang=js"
export * from "./DashItem.vue?vue&type=script&lang=js"
import style0 from "./DashItem.vue?vue&type=style&index=0&id=73f3edee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f3edee",
  null
  
)

export default component.exports